import { Layout } from 'react-grid-layout'
import { CustomReportSectionsType } from '../../../../../redux/context/customReports/typesSection'
import { ROW_HEIGHT } from '../grid.utils'

export interface GridTemplate {
  areas: string
  rows: string
  sectionMap: Map<string, CustomReportSectionsType>
  heightMap: Map<string, number>
  colSpanMap: Map<string, number>
}

export const areaName = (id: number | string) => `s${id}`

export const PRINT_ROW_HEIGHT = ROW_HEIGHT * 1.5

export const buildGridTemplate = (sections: CustomReportSectionsType[], lgLayout?: Layout[]): GridTemplate => {
  const sectionMap = new Map(sections.map(s => [areaName(s.id), s]))

  const heightMap = new Map<string, number>()
  const colSpanMap = new Map<string, number>()

  if (!lgLayout || lgLayout.length === 0) {
    const areas = sections.map(s => `"${Array(12).fill(areaName(s.id)).join(' ')}"`).join('\n')
    sections.forEach(s => colSpanMap.set(areaName(s.id), 12))
    return { areas, rows: sections.map(() => 'auto').join(' '), sectionMap, heightMap, colSpanMap }
  }

  for (const item of lgLayout) {
    heightMap.set(areaName(item.i), item.h * PRINT_ROW_HEIGHT)
    colSpanMap.set(areaName(item.i), item.w)
  }

  const yBreaks = new Set<number>()
  for (const item of lgLayout) {
    yBreaks.add(item.y)
    yBreaks.add(item.y + item.h)
  }
  const sortedBreaks = [...yBreaks].sort((a, b) => a - b)

  const rowStrings: string[] = []
  const rowHeights: string[] = []

  for (let i = 0; i < sortedBreaks.length - 1; i += 1) {
    const yMid = sortedBreaks[i]
    const bandUnits = sortedBreaks[i + 1] - sortedBreaks[i]
    const bandPx = bandUnits * PRINT_ROW_HEIGHT
    const cols: string[] = Array(12).fill('.')
    const bandItems = lgLayout.filter(item => item.y <= yMid && item.y + item.h > yMid)

    for (const item of bandItems) {
      for (let c = item.x; c < item.x + item.w && c < 12; c += 1) {
        cols[c] = areaName(item.i)
      }
    }

    if (bandItems.length > 0) {
      const hasTable = bandItems.some(item => sectionMap.get(areaName(item.i))?.type === 'table')
      rowStrings.push(`"${cols.join(' ')}"`)
      rowHeights.push(hasTable ? 'auto' : `minmax(${bandPx}px, auto)`)
    }
  }

  return {
    areas: rowStrings.join('\n'),
    rows: rowHeights.join(' '),
    sectionMap,
    heightMap,
    colSpanMap
  }
}
